/* director-diseno 5 oct (dirección B): barra "Tu caja" arriba, tres escalones: $199, $99 desde $800, gratis y regalo desde $1,500.
   Barra de un escalón (Carlos 2026-09-14): desde $1,500 envío gratis y regalo snack sorpresa juntos.
   El regalo (variante $0, producto oculto) se agrega o quita solo según el subtotal sin el regalo.
   Una lectura inicial y una por cambio real. No intercepta fetch ni usa polling. */
(() => {
  const bar = document.getElementById('sd-envio');
  if (!bar) return;
  const ENVIO = 150000, REGALO = 150000, GIFT = 45447637958838, MINIMO = 0; // sin pedido mínimo desde el 30 sep 2026 (antes 49900, Carlos 2026-09-16), igual que la condición de las tarifas de envío
  const text = document.getElementById('sd-envio-tx');
  const fill = document.getElementById('sd-envio-fill');
  const track = fill && fill.parentElement;
  const fill2 = document.getElementById('sd-envio-fill2'), MEDIO = 80000;
  let pending = false, dirty = false, ajustando = false;
  const root = window.Shopify?.routes?.root || '/';
  const money = cents => (cents / 100).toLocaleString('es-MX', {style: 'currency', currency: 'MXN', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: cents % 100 ? 2 : 0}); // 5 oct: centavos cuando los hay, para que las cuentas cuadren
  const post = (url, body) => fetch(root + url, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
  async function refresh() {
    if (pending) { dirty = true; return; }
    pending = true;
    try {
      const response = await fetch(`${root}cart.js`, {headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('No se pudo leer el carrito');
      const cart = await response.json();
      const giftLine = cart.items.find(i => i.variant_id === GIFT);
      const total = cart.total_price; // ya con cupones: igual que el envío gratis de Shopify (el regalo vale $0)
      const productos = cart.items.filter(i => i.variant_id !== GIFT).length;
      // regalo automático: una sola pieza, solo desde $1,500 sin contar el regalo
      if (!ajustando) {
        let cambio = null;
        if (total >= REGALO && !giftLine) cambio = post('cart/add.js', {items: [{id: GIFT, quantity: 1}]});
        else if (giftLine && (total < REGALO || giftLine.quantity !== 1)) cambio = post('cart/change.js', {id: giftLine.key, quantity: total < REGALO ? 0 : 1});
        if (cambio) {
          ajustando = true;
          await cambio.catch(() => {});
          ajustando = false; pending = false;
          if (location.pathname.replace(root, '/').startsWith('/cart')) { /* 5 oct: sin recargar la página; sd-v3-cart.js repinta el carrito */ if (window.sdCartRepinta) { try { await window.sdCartRepinta(); } catch (_) { location.reload(); return; } return refresh(); } location.reload(); return; }
          return refresh();
        }
      }
      document.documentElement.classList.toggle('sd-bajo-minimo', productos > 0 && total < MINIMO);
      bar.dataset.ver = '1';
      fill.style.width = `${Math.min(100, total / MEDIO * 100)}%`;
      const cam = document.getElementById('sd-envio-camion'), reg = document.getElementById('sd-envio-regalo');
      if (cam) cam.style.left = `${Math.min(100, total / REGALO * 100)}%`;
      if (reg) reg.classList.toggle('is-ok', total >= REGALO);
      if (fill2) fill2.style.width = `${Math.max(0, Math.min(100, (total - MEDIO) / (REGALO - MEDIO) * 100))}%`;
      const ctaV = bar.querySelector('.sd-cta'); if (ctaV) ctaV.hidden = !productos;
      if (!productos) text.innerHTML = '<b>Arma tu pedido:</b> envío $99 y rifa de Halloween desde $800; gratis y regalo desde $1,500';
      else if (total >= REGALO) text.innerHTML = '<b>¡Listo!</b> Envío gratis, snack de regalo y ya participas en la rifa de Halloween';
      else if (total >= MEDIO) text.innerHTML = `<b>Llevas ${money(total)}.</b> Ya participas en la rifa. Faltan ${money(REGALO - total)} para envío gratis y regalo`;
      else text.innerHTML = `<b>Llevas ${money(total)}.</b> Faltan ${money(MEDIO - total)} para envío a $99 y entrar a la rifa`;
    } catch (_) { bar.removeAttribute('data-ver'); }
    finally { pending = false; if (dirty) { dirty = false; refresh(); } }
  }
  function afterCartUpdate(event) {
    // Horizon emite el evento antes del POST y resuelve promise con el carrito confirmado.
    if (event.promise && typeof event.promise.then === 'function') event.promise.then(refresh).catch(() => {});
    else refresh();
  }
  document.addEventListener('shopify:cart:lines-update', afterCartUpdate);
  document.addEventListener('shopify:cart:discount-update', afterCartUpdate);
  window.addEventListener('pageshow', refresh);
  // Tarea 31: el agregado rápido de portada y colección solo reescribe .cart-counter; se observa ese contador.
  document.querySelectorAll('.cart-counter').forEach((counter) => {
    new MutationObserver(() => { if (!ajustando) refresh(); }).observe(counter, {childList: true, characterData: true, subtree: true});
  });
})();
